export default {"src":"/_next/static/media/red_timer.191a5eb2.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};